<div class="card card-custom" style="height: 100%">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Intervention History - {{ data.drp.title }}</h3>
    </div>
    <div class="card-toolbar">
      <div class="d-flex flex-column" style="padding-top: 100%">
        <div>
          <i class="ki ki-more-ver icon-md cursor-pointer" (click)="mySelect.open()"></i>
          <mat-select class="hide-trigger" #mySelect style="height: 0">
            <mat-option (click)="ignore(data.drp)"> No Further Interventions Necessary </mat-option>
            <mat-option (click)="manageProblem()"> Start a new Intervention </mat-option>
            <mat-option (click)="pendProblem(data.drp)"> Review at a later date </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </div>
  <div class="navi-hover scroll card-body" style="max-height: 80vh">
    <div class="mat-table-wrapper" style="overflow-x: hidden; max-height: 400px">
      <mat-table
        class="lmat-elevation-z8"
        #table
        [dataSource]="dataSource"
        matSort
        #sort1="matSort"
        matSortActive="id"
        matSortDirection="desc"
        matSortDisableClear
      >
        <ng-container matColumnDef="interventionCode_level_level">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Level </mat-header-cell>
          <mat-cell *matCellDef="let interventionHistory">{{
            interventionHistory.intervention_code.level.level
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="team_responsible">
          <mat-header-cell *matHeaderCellDef>Team </mat-header-cell>
          <mat-cell *matCellDef="let interventionHistory">{{
            getTeam(interventionHistory.team_responsible)
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="interventionNote">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Note </mat-header-cell>
          <mat-cell *matCellDef="let interventionHistory">{{
            interventionHistory.intervention_note
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="acceptanceResult_implementation">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Acceptance </mat-header-cell>
          <mat-cell *matCellDef="let interventionHistory">{{
            interventionHistory.acceptance_result
              ? interventionHistory.acceptance_result.implementation
              : ''
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="drp_outcomeCode">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Outcome </mat-header-cell>
          <mat-cell *matCellDef="let interventionHistory">{{
            interventionHistory.drp.outcome.outcome
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="startDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Start Date </mat-header-cell>
          <mat-cell *matCellDef="let interventionHistory">{{
            interventionHistory.start_date | date : 'MM-dd-yyyy'
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="stopDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Completed Date </mat-header-cell>
          <mat-cell *matCellDef="let interventionHistory">{{
            interventionHistory.stop_date | date : 'MM-dd-yyyy'
          }}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>

        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          (dblclick)="openInterventionTask(row)"
          matTooltip="View Intervention Task"
        ></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource.hasItems" translate>
        GLOBAL.NO_RECORDS_FOUND
      </div>
      <div class="mat-table-message" *ngIf="dataSource.isPreloadTextViewed$ | async" translate>
        GLOBAL.PLEASE_WAIT
      </div>
    </div>
    <div class="mat-table-bottom">
      <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </div>
  <div class="card-footer">
    <div class="row">
      <div class="col-lg-9"></div>
      <div class="col-lg-3" style="text-align: right">
        <button
          (click)="close()"
          type="button"
          mat-raised-button
          cdkFocusInitial
          matTooltip="Cancel"
        >
          <span translate="GLOBAL.CLOSE">Close</span>
        </button>
      </div>
    </div>
  </div>
</div>
